import { render, staticRenderFns } from "./ProgramPaymentsVouchers.vue?vue&type=template&id=672c61aa&"
import script from "./ProgramPaymentsVouchers.vue?vue&type=script&lang=js&"
export * from "./ProgramPaymentsVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports